import { call, put, takeLatest } from 'redux-saga/effects';

import {
	attendanceReport,
	createProgramAndSession,
	deactivateProgramAPI,
	deleteProgramAPI,
	enrollmentCountsReport,
	fetchGroupTypes,
	fetchMyGroupsAPI,
	reactivateProgramAPI,
	updateProgramAndSession,
} from 'utils/api';
import { getErrorMessage } from 'utils/errorUtils';

import { generateToast } from 'containers/App/actions';
import {
	createProgramError,
	createProgramSuccess,
	deactivateProgramError,
	deleteProgramError,
	downloadAttendanceReportError,
	downloadEnrollmentCountsReportError,
	loadGroupTypesError,
	loadGroupTypesSuccess,
	loadPrograms,
	loadProgramsError,
	loadProgramsSuccess,
	reactivateProgramError,
	updateProgramConflict,
	updateProgramError,
	updateProgramSuccess,
} from './actions';
import {
	CREATE_PROGRAM,
	CREATE_PROGRAM_SUCCESS,
	DEACTIVATE_PROGRAM,
	DEACTIVATE_PROGRAM_SUCCESS,
	DELETE_PROGRAM,
	DELETE_PROGRAM_SUCCESS,
	DOWNLOAD_ATTENDANCE_REPORT,
	DOWNLOAD_ENROLLMENT_COUNTS_REPORT,
	LOAD_GROUP_TYPES,
	LOAD_PROGRAMS,
	REACTIVATE_PROGRAM,
	UPDATE_PROGRAM,
} from './constants';

export default function* therapiesSaga() {
	yield takeLatest(LOAD_GROUP_TYPES, getGroupTypes);
	yield takeLatest(LOAD_PROGRAMS, getPrograms);
	yield takeLatest(CREATE_PROGRAM, createProgram);
	yield takeLatest(UPDATE_PROGRAM, updateProgram);
	yield takeLatest(CREATE_PROGRAM_SUCCESS, getPrograms);
	yield takeLatest(DELETE_PROGRAM, deleteProgram);
	yield takeLatest(DELETE_PROGRAM_SUCCESS, deleteProgram);
	yield takeLatest(CREATE_PROGRAM_SUCCESS, getPrograms);
	yield takeLatest(DEACTIVATE_PROGRAM, deactivateProgram);
	yield takeLatest(DEACTIVATE_PROGRAM_SUCCESS, deactivateProgram);
	yield takeLatest(REACTIVATE_PROGRAM, reactivateProgram);
	yield takeLatest(DOWNLOAD_ATTENDANCE_REPORT, downloadAttendanceReport);
	yield takeLatest(
		DOWNLOAD_ENROLLMENT_COUNTS_REPORT,
		downloadEnrollmentCountsReport,
	);
	// See example in containers/HomePage/saga.js
}

export function* getGroupTypes() {
	try {
		// Call our request helper (see 'utils/api')
		const response = yield call(fetchGroupTypes);
		yield put(loadGroupTypesSuccess(response));
	} catch (err) {
		yield put(loadGroupTypesError(err));
	}
}

export function* createProgram(actions) {
	try {
		const { data } = actions;
		const response = yield call(createProgramAndSession, data);
		if (response.response && response.response.status >= 400) {
			const message = getErrorMessage(response);
			yield put(createProgramError(message));
			yield put(generateToast({ type: 'error', text: message }));
		} else {
			yield put(createProgramSuccess(response.data));
		}
	} catch (err) {
		const message = getErrorMessage(err);
		yield put(createProgramError(message));
		yield put(generateToast({ type: 'error', text: message }));
	}
}

export function* updateProgram(actions) {
	try {
		const { data, onSuccess } = actions;
		const response = yield call(updateProgramAndSession, data);
		if (response.response && response.response.status >= 400) {
			const conflictData = response.response.data;
			if (
				response.response.status === 409 &&
				conflictData &&
				conflictData.warning &&
				Array.isArray(conflictData.affectedSessions) &&
				conflictData.affectedSessions.length > 0
			) {
				yield put(updateProgramConflict(conflictData));
			} else {
				const message = getErrorMessage(response);
				yield put(updateProgramError(message));
				yield put(generateToast({ type: 'error', text: message }));
			}
		} else {
			yield put(updateProgramSuccess(data));
			if (onSuccess) {
				onSuccess(response);
			}
		}
	} catch (err) {
		const message = getErrorMessage(err);
		yield put(updateProgramError(message));
		yield put(generateToast({ type: 'error', text: message }));
	}
}

export function* deleteProgram(actions) {
	try {
		const { data } = actions;
		const response = yield call(deleteProgramAPI, data);
		if (response.response && response.response.status >= 400) {
			yield put(deleteProgramError());
		} else {
			yield put(loadPrograms());
		}
	} catch (err) {
		yield put(deleteProgramError(err));
	}
}

export function* deactivateProgram(actions) {
	try {
		const { data } = actions;
		const response = yield call(deactivateProgramAPI, data);
		if (response.response && response.response.status >= 400) {
			yield put(deactivateProgramError());
		} else {
			yield put(loadPrograms());
		}
	} catch (err) {
		yield put(deactivateProgramError(err));
	}
}

export function* reactivateProgram(actions) {
	try {
		const { data } = actions;
		const response = yield call(reactivateProgramAPI, data);
		if (response.response && response.response.status >= 400) {
			yield put(reactivateProgramError());
		} else {
			yield put(loadPrograms());
		}
	} catch (err) {
		yield put(reactivateProgramError(err));
	}
}

export function* getPrograms() {
	try {
		const response = yield call(fetchMyGroupsAPI);
		yield put(loadProgramsSuccess(response));
	} catch (err) {
		yield put(loadProgramsError(err));
	}
}

export function* downloadAttendanceReport(actions) {
	try {
		const { data } = actions;
		yield call(attendanceReport, data);
		// yield put(loadProgramsSuccess(response));
	} catch (err) {
		yield put(downloadAttendanceReportError(err));
	}
}

export function* downloadEnrollmentCountsReport() {
	try {
		yield call(enrollmentCountsReport);
	} catch (err) {
		yield put(downloadEnrollmentCountsReportError(err));
	}
}
